<template>
  <div>
    <a-form-model
      class="fromStyle"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item ref="device_name" label="网点名称" prop="device_name">
        <a-input style="width:300px" v-model="form.device_name" />
      </a-form-model-item>
      <a-form-model-item label="项目" ref="project_id" prop="project_id">
        <a-select
          style="width:300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          placeholder="请选择项目"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item ref="cityVal" label="所在" prop="cityVal">
        <area-select
          :level="2"
          type="text"
          :data="pcaa"
          v-model="form.cityVal"
        ></area-select>
      </a-form-model-item>
      <a-form-model-item ref="address" label="详细地址" prop="address">
        <a-input style="width:300px" v-model="form.address" />
      </a-form-model-item>
      <a-form-model-item ref="firm_id" label="设备厂商" prop="firm_id">
        <a-radio-group v-model="form.firm_id">
          <a-radio :value="1">易触</a-radio>
          <a-radio :value="2">华屹1</a-radio>
          <a-radio :value="3">华屹2</a-radio>
          <a-radio :value="4">卡游</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        ref="device_unique_id"
        label="设备编号"
        prop="device_unique_id"
      >
        <a-input style="width:300px" v-model="form.device_unique_id" />
      </a-form-model-item>
      <a-form-model-item ref="version" label="设备类型" prop="version">
        <a-radio-group v-model="form.version">
          <a-radio :value="1">一代机</a-radio>
          <a-radio :value="2">二代机</a-radio>
          <a-radio :value="3">三代机</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item ref="sale_type" label="销售情况" prop="sale_type">
        <a-radio-group v-model="form.sale_type">
          <a-radio :value="1">非热销</a-radio>
          <a-radio :value="2">热销</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 5 }">
        <a-button @click="resetForm">
          重置
        </a-button>
        <a-button style="margin-left: 10px;" type="primary" @click="onSubmit">
          提交
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import { pcaa } from "area-data";
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      form: {
        device_name: "",
        project_id: "",
        province: "",
        city: "",
        area: "",
        address: "",
        cityVal: ["上海市", "市辖区", "黄浦区"],
        firm_id: "",
        device_unique_id: "",
        version: "",
        sale_type: ""
      },
      rules: {
        device_name: [
          {
            required: true,
            message: "请输入网点名称",
            trigger: "blur"
          }
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        firm_id: [
          {
            required: true,
            message: "请选择设备厂商",
            trigger: "change"
          }
        ],
        device_unique_id: [
          {
            required: true,
            message: "请输入设备编号",
            trigger: "blur"
          }
        ],
        cityVal: [
          {
            required: true,
            message: "请输入省市区",
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur"
          }
        ],
        version: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "change"
          }
        ],
        sale_type: [
          {
            required: true,
            message: "请选择销售类型",
            trigger: "change"
          }
        ]
      },
      proList: [],
      pcaa: pcaa
    };
  },
  mounted() {
    this.getPro();
  },
  methods: {
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // alert("submit!");
          let url =
            this.httpsBasic.url + this.httpsBasic.equipment + "Device/add";
          this.form.area = this.form.cityVal[2];
          if (
            this.form.cityVal[0] == "上海市" ||
            this.form.cityVal[0] == "天津市" ||
            this.form.cityVal[0] == "北京市" ||
            this.form.cityVal[0] == "重庆市"
          ) {
            this.form.province = this.form.cityVal[0];
            this.form.city = this.form.cityVal[0];
          } else {
            this.form.province = this.form.cityVal[0];
            this.form.city = this.form.cityVal[1];
          }
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            device_name: this.form.device_name,
            project_id: this.form.project_id,
            firm_id: this.form.firm_id,
            device_unique_id: this.form.device_unique_id,
            version: this.form.version,
            sale_type: this.form.sale_type,
            province: this.form.province,
            city: this.form.city,
            area: this.form.area,
            address: this.form.address
          };
          // console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.$emit("hideInAdd", true);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style lang="less">
.fromStyle {
  margin-top: 30px;
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
    line-height: 32px;
  }
}
</style>
